import { ViewCancelForm } from '@actions/novaOrdemActions';
import { useAppDispatch, useAppSelector } from '@config/reduxStore';
import { CancelarOrdem } from '@services/api/api.ordem';
import { Form, Input, Modal } from 'antd';

type FormData = {
  motivo: string;
};

function CancelOrdemModal() {
  const dispatch = useAppDispatch();
  const { cancelForm } = useAppSelector((state) => state.novaOrdem);
  const cancelarOrdem = CancelarOrdem();
  const [form] = Form.useForm<FormData>();
  const handleSubmit = (values: FormData) => {
    if (cancelForm.replace) {
      cancelarOrdem.mutate({ id: cancelForm.id, motivo: values.motivo, replaced: true, cod: cancelForm.cod });
    } else cancelarOrdem.mutate({ id: cancelForm.id, motivo: values.motivo, replaced: false, cod: cancelForm.cod });
  };
  return (
    <Modal
      open={cancelForm.visible}
      title="Razão do cancelamento/substituição"
      onCancel={() => {
        dispatch(ViewCancelForm({ id: null, view: false, replace: false, cod: null }));
      }}
      okButtonProps={{ loading: cancelarOrdem.isLoading }}
      onOk={() => form.submit()}
    >
      <Form form={form} onFinish={handleSubmit}>
        <Form.Item rules={[{ required: true, message: 'Campo obrigatório' }]} name="motivo">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
}
export default CancelOrdemModal;
